import React, { useState } from 'react'
import { Card, CardContent, Box, Tab } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import SwitchRow from '../Rows/SwitchRow'
import NumberRow from '../Rows/NumberRow'
import ListRow from '../Rows/ListRow'
import TextRow from '../Rows/TextRow'
import { Shadow } from '../../types/Shadow.types'
import { FormTabProps } from '../../types/FormTab.types'

const ApplicationTab = ({ formState, handleChangeByShadow }: FormTabProps) => {
    const [currentApplicationTab, setCurrentApplicationTab] = useState('language')

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setCurrentApplicationTab(newValue)
    }

    const getShowLastDistributionsValue = (value: boolean | string | null): string => {
        if (value == null) return ''

        if (typeof value === 'boolean') return value ? 'yes' : 'no'

        const v = String(value).toLowerCase()
        if (v === 'true') return 'yes'
        if (v === 'false') return 'no'

        return String(value)
    }

    const inputChanged = handleChangeByShadow(Shadow.Vend);

    return (
        <Box className="sub-card-container" sx={{ height: '100%' }}>
            <TabContext value={currentApplicationTab}>
                <TabList onChange={handleTabChange} orientation="vertical" sx={{ width: '174px', height: '120%' }}>
                    <Tab label="Język" value="language" className="sub-card-tab" sx={{ color: '#858585' }} />
                    <Tab label="Sesja użytkownika" value="userSession" className="sub-card-tab"
                         sx={{ color: '#858585' }} />
                    <Tab label="Ładowanie" value="loading" className="sub-card-tab" sx={{ color: '#858585' }} />
                    <Tab label="Dystrybucja" value="distribution" className="sub-card-tab" sx={{ color: '#858585' }} />
                    <Tab label="Zwrot" value="return" className="sub-card-tab" sx={{ color: '#858585' }} />
                    <Tab label="Doładowywanie" value="replenishment" className="sub-card-tab"
                         sx={{ color: '#858585' }} />
                    <Tab label="Etykietowanie komórek" value="cellsLabeling" className="sub-card-tab"
                         sx={{ color: '#858585' }} />
                    <Tab label="Egzemplarze produktów" value="productItems" className="sub-card-tab"
                         sx={{ color: '#858585' }} />
                    <Tab label="Zlecenie dystrybucji" value="distributionRequests" className="sub-card-tab"
                         sx={{ color: '#858585' }} />
                    <Tab label="Przesunięcia magazynowe" value="inventoryTransfers" className="sub-card-tab"
                         sx={{ color: '#858585' }} />
                    <Tab label="Integracja VSD" value="vsd" className="sub-card-tab" sx={{ color: '#858585' }} />
                    <Tab label="Frontend" value="frontend" className="sub-card-tab" sx={{ color: '#858585' }} />
                    <Tab label="Backend" value="backend" className="sub-card-tab" sx={{ color: '#858585' }} />
                </TabList>
                <Card sx={{ width: '77%', p: 0 }} variant="outlined" className="card-configuration">
                    <CardContent sx={{ p: 2 }} className="card-configuration">
                        <TabPanel value="language" sx={{ p: 0 }} className="configuration-option">
                            <ListRow
                                label="Język interfejsu automatu"
                                caption="LANGUAGE"
                                name="vend.LANGUAGE"
                                value={formState.vend.LANGUAGE}
                                onChange={inputChanged}
                                items={['EN', 'DE', 'PL', 'CS', 'RU', 'SI', 'LV', 'LT', 'RO', 'SK', 'SR', 'NL', 'DA', 'UA', 'HR', 'HU']}
                            />

                            <SwitchRow
                                label="Wymuszenie prezentacji tekstu tłumaczeń dużymi literami"
                                caption="TRANSLATION_ENFORCE_UPPER_CASE"
                                switchName="vend.TRANSLATION_ENFORCE_UPPER_CASE"
                                checked={formState.vend.TRANSLATION_ENFORCE_UPPER_CASE}
                                onChange={inputChanged}
                            />

                            <TextRow
                                label="Nazwa pliku z tłumaczeniami komunikatów"
                                caption="TRANSLATION_FILE"
                                name="vend.TRANSLATION_FILE"
                                value={formState.vend.TRANSLATION_FILE}
                                onChange={inputChanged}
                            />

                        </TabPanel>
                        <TabPanel value="userSession" sx={{ p: 0 }} className="configuration-option">
                            <SwitchRow
                                label="Ograniczenie dostępu do automatu tylko dla pracowników przypisanych do maszyny w IDS"
                                caption="RESTAPI_ONLY_ASSIGNED_USERS"
                                switchName="vend.RESTAPI_ONLY_ASSIGNED_USERS"
                                checked={formState.vend.RESTAPI_ONLY_ASSIGNED_USERS}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Umożliwienie autoryzacji bez podania PINu"
                                caption="UI_ENABLE_USER_AUTH_WITHOUT_PIN"
                                switchName="vend.UI_ENABLE_USER_AUTH_WITHOUT_PIN"
                                checked={formState.vend.UI_ENABLE_USER_AUTH_WITHOUT_PIN}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Umożliwienie wykropkowania numerycznego identyfikatora"
                                caption="UI_AUTH_USER_INPUT_TEXT_HIDDEN"
                                switchName="vend.UI_AUTH_USER_INPUT_TEXT_HIDDEN"
                                checked={formState.vend.UI_AUTH_USER_INPUT_TEXT_HIDDEN}
                                onChange={inputChanged}
                            />

                            <ListRow
                                label="Domyślny ekran widoczny po rozpoczęciu sesji"
                                caption="UI_US_DEF_VIEW"
                                name="vend.UI_US_DEF_VIEW"
                                value={formState.vend.UI_US_DEF_VIEW}
                                onChange={inputChanged}
                                items={['MAIN_MENU', 'PRODUCT_CATALOG']}
                            />

                            <SwitchRow
                                label="Wyświetlanie danych użytkownika po zalogowaniu"
                                caption="UI_SHOW_INFO_AFTER_LOGIN"
                                switchName="vend.UI_SHOW_INFO_AFTER_LOGIN"
                                checked={formState.vend.UI_SHOW_INFO_AFTER_LOGIN}
                                onChange={inputChanged}
                            />

                            <NumberRow
                                label="Okres nieaktywności użytkownika po którym nastąpi automatyczne wylogowanie (sekundy)"
                                caption="UI_SHORT_INACTIVITY_TIMEOUT"
                                name="vend.UI_SHORT_INACTIVITY_TIMEOUT"
                                value={formState.vend.UI_SHORT_INACTIVITY_TIMEOUT}
                                onChange={inputChanged}
                            />

                            <NumberRow
                                label="Okres nieaktywnośc użytkownika po którym nastąpi automatyczne wylogowanie z ekranu nie wymagającego szybkiej reakcji użytkownika (sekundy)"
                                caption="UI_LONG_INACTIVITY_TIMEOUT"
                                name="vend.UI_LONG_INACTIVITY_TIMEOUT"
                                value={formState.vend.UI_LONG_INACTIVITY_TIMEOUT}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Zmiana języka aplikacji na język użytkownika"
                                caption="UI_SWITCH_USER_LANGUAGE"
                                switchName="vend.UI_SWITCH_USER_LANGUAGE"
                                checked={formState.vend.UI_SWITCH_USER_LANGUAGE}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Wyświetlenie zapytania czy wznowić sesję użytkownika po udanej dystrybucji"
                                caption="UI_SHOW_AFTER_SUCCESSFUL_DISTRIBUTION_CONTINUATION_QUESTION"
                                switchName="vend.UI_SHOW_AFTER_SUCCESSFUL_DISTRIBUTION_CONTINUATION_QUESTION"
                                checked={formState.vend.UI_SHOW_AFTER_SUCCESSFUL_DISTRIBUTION_CONTINUATION_QUESTION}
                                onChange={inputChanged}
                            />

                            <NumberRow
                                label="Okres oczekiwania na odpowiedź użytkownika czy wznowić sesję użytkownika po udanej dystrybucji (sekundy)"
                                caption="UI_AFTER_SUCCESSFUL_DISTRIBUTION_CONTINUATION_QUESTION_TIMEOUT"
                                name="vend.UI_AFTER_SUCCESSFUL_DISTRIBUTION_CONTINUATION_QUESTION_TIMEOUT"
                                value={formState.vend.UI_AFTER_SUCCESSFUL_DISTRIBUTION_CONTINUATION_QUESTION_TIMEOUT}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Odbicie się nieprzypisaną kartą przy automacie wyświetli możliwość przypisania karty z poziomu automatu do użytkownika, który zaloguje się loginem numerycznym i PINem"
                                caption="VM_SELFSERVICE_TAG_ASSIGNMENT"
                                switchName="vend.VM_SELFSERVICE_TAG_ASSIGNMENT"
                                checked={formState.vend.VM_SELFSERVICE_TAG_ASSIGNMENT}
                                onChange={inputChanged}
                            />

                        </TabPanel>
                        <TabPanel value="loading" sx={{ p: 0 }} className="configuration-option">
                            <SwitchRow
                                label="Ukrycie w głównym menu kafelka z operacją załadunku przez klapy"
                                caption="UI_HIDE_LOADING_THROUGH_FLAPS"
                                switchName="vend.UI_HIDE_LOADING_THROUGH_FLAPS"
                                checked={formState.vend.UI_HIDE_LOADING_THROUGH_FLAPS}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Ukrycie w głównym menu operacji załadunku grup produktów"
                                caption="UI_HIDE_LOADING_GROUP_OF_PRODUCTS"
                                switchName="vend.UI_HIDE_LOADING_GROUP_OF_PRODUCTS"
                                checked={formState.vend.UI_HIDE_LOADING_GROUP_OF_PRODUCTS}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Ukrycie w głównym menu operacji załadunku z użyciem skanera komórek"
                                caption="UI_HIDE_LOADING_WITH_CELL_SCANNER"
                                switchName="vend.UI_HIDE_LOADING_WITH_CELL_SCANNER"
                                checked={formState.vend.UI_HIDE_LOADING_WITH_CELL_SCANNER}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Automatyczne tworzenie schematu załadunku podczas ładowania przez klapy"
                                caption="VM_SET_CELL_SCHEMA_WHILE_LOADING"
                                switchName="vend.VM_SET_CELL_SCHEMA_WHILE_LOADING"
                                checked={formState.vend.VM_SET_CELL_SCHEMA_WHILE_LOADING}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Ograniczenie prezentacji produktów, podczas ładowania przez klapy, tylko do tych, które mają przypisane limity w stanach bieżących dla danego punktu dystrybucyjnego"
                                caption="UI_SHOW_ONLY_ASSIGNED_PRODUCTS_WHILE_LOADING"
                                switchName="vend.UI_SHOW_ONLY_ASSIGNED_PRODUCTS_WHILE_LOADING"
                                checked={formState.vend.UI_SHOW_ONLY_ASSIGNED_PRODUCTS_WHILE_LOADING}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Blokowanie możliwości ładowania przez klapy jeżeli schemat załadunku dla komórki jest ustawiony"
                                caption="VM_PREVENT_LOADING_CELLS_WITH_SCHEMA"
                                switchName="vend.VM_PREVENT_LOADING_CELLS_WITH_SCHEMA"
                                checked={formState.vend.VM_PREVENT_LOADING_CELLS_WITH_SCHEMA}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Ignorowanie wielopaków zdefiniowanych w IDS, podczas załadunku produktów"
                                caption="UI_DO_NOT_USE_DEFINED_MULTIPACKS"
                                switchName="vend.UI_DO_NOT_USE_DEFINED_MULTIPACKS"
                                checked={formState.vend.UI_DO_NOT_USE_DEFINED_MULTIPACKS}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Ukrycie egzemplarzy produktów nieprzypisanych do żadnego punktu dystrybucyjnego"
                                caption="UI_SHOW_ONLY_ASSIGNED_PRODUCT_ITEMS_WHILE_LOADING"
                                switchName="vend.UI_SHOW_ONLY_ASSIGNED_PRODUCT_ITEMS_WHILE_LOADING"
                                checked={formState.vend.UI_SHOW_ONLY_ASSIGNED_PRODUCT_ITEMS_WHILE_LOADING}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Wyświetlanie struktury drzewiastej podczas załadunku"
                                caption="UI_SHOW_TREE_STRUCTURE_ON_LOADING"
                                switchName="vend.UI_SHOW_TREE_STRUCTURE_ON_LOADING"
                                checked={formState.vend.UI_SHOW_TREE_STRUCTURE_ON_LOADING}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Wyświetlanie tylko produktów przypisanych do użytkownika podczas załadunku"
                                caption="UI_SHOW_ONLY_ASSIGNED_TO_USER_ON_LOADING"
                                switchName="vend.UI_SHOW_ONLY_ASSIGNED_TO_USER_ON_LOADING"
                                checked={formState.vend.UI_SHOW_ONLY_ASSIGNED_TO_USER_ON_LOADING}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Wyświetlanie tylko załadowanych produktów podczas załadunku"
                                caption="UI_SHOW_ZERO_PROD_ON_LOADING"
                                switchName="vend.UI_SHOW_ZERO_PROD_ON_LOADING"
                                checked={formState.vend.UI_SHOW_ZERO_PROD_ON_LOADING}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Możliwość przełączania filtrów podczas załadunku"
                                caption="UI_SWITCHING_FILTERS_ON_LOADING"
                                switchName="vend.UI_SWITCHING_FILTERS_ON_LOADING"
                                checked={formState.vend.UI_SWITCHING_FILTERS_ON_LOADING}
                                onChange={inputChanged}
                            />
                        </TabPanel>
                        <TabPanel value="distribution" sx={{ p: 0 }} className="configuration-option">
                            <SwitchRow
                                label="Włączenie wyświetlania produktów niezaładowanych do podajnika"
                                caption="UI_SHOW_ZERO_PROD"
                                switchName="vend.UI_SHOW_ZERO_PROD"
                                checked={formState.vend.UI_SHOW_ZERO_PROD}
                                onChange={inputChanged}
                            />

                            <ListRow
                                label="Poziom filtrowania produktów"
                                caption="UI_PRODUCT_FILTER_LEVEL"
                                name="vend.UI_PRODUCT_FILTER_LEVEL"
                                value={formState.vend.UI_PRODUCT_FILTER_LEVEL}
                                onChange={inputChanged}
                                items={['ACCESSIBLE_AND_UNDER_LIMIT', 'ACCESSIBLE_AND_OVER_LIMIT', 'ALL']}
                            />

                            <SwitchRow
                                label="Wyświetlanie karty produktu"
                                caption="UI_SHOW_PROD_CARD"
                                switchName="vend.UI_SHOW_PROD_CARD"
                                checked={formState.vend.UI_SHOW_PROD_CARD}
                                onChange={inputChanged}
                            />

                            <SwitchRow
                                label="Wyświetlanie wszystkich centrów kosztów"
                                caption="UI_SHOW_ALL_COST_CENTERS"
                                switchName="vend.UI_SHOW_ALL_COST_CENTERS"
                                checked={formState.vend.UI_SHOW_ALL_COST_CENTERS}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Wydawanie produktów z wykorzystaniem koszyka produktów"
                                caption="UI_DISTRIBUTION_WITH_BASKET"
                                switchName="vend.UI_DISTRIBUTION_WITH_BASKET"
                                checked={formState.vend.UI_DISTRIBUTION_WITH_BASKET}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Maksymalna ilość pozycji w koszyku"
                                caption="UI_BASKET_SIZE"
                                name="vend.UI_BASKET_SIZE"
                                value={formState.vend.UI_BASKET_SIZE}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Pobieranie częściowe"
                                caption="UI_FORCE_PARTIAL_COLLECTION"
                                switchName="vend.UI_FORCE_PARTIAL_COLLECTION"
                                checked={formState.vend.UI_FORCE_PARTIAL_COLLECTION}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Nielimitowany profil pobierania"
                                caption="UI_FORCE_UNLIMITED_ACCESS_PROFILE"
                                switchName="vend.UI_FORCE_UNLIMITED_ACCESS_PROFILE"
                                checked={formState.vend.UI_FORCE_UNLIMITED_ACCESS_PROFILE}
                                onChange={inputChanged}
                            />
                            <ListRow
                                label="Wyświetlenie listy ostatnich pobrań dla produktów niezaładowanych przy próbie pobrania"
                                caption="UI_SHOW_LAST_DISTRIBUTIONS_OF_PRODUCT"
                                name="vend.UI_SHOW_LAST_DISTRIBUTIONS_OF_PRODUCT"
                                value={getShowLastDistributionsValue(formState.vend.UI_SHOW_LAST_DISTRIBUTIONS_OF_PRODUCT)}
                                onChange={inputChanged}
                                items={['yes', 'no', 'ONLY4RENTABLE']}
                            />
                            <SwitchRow
                                label="Limitowanie produktów dla użytkownika bez uwzględniana zwrotów"
                                caption="UI_USER_PRODUCT_LIMIT_WITHOUT_RETURNS"
                                switchName="vend.UI_USER_PRODUCT_LIMIT_WITHOUT_RETURNS"
                                checked={formState.vend.UI_USER_PRODUCT_LIMIT_WITHOUT_RETURNS}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Nowa logika limitowania polegająca na blokadzie wydania tego samego produktu, dopóki wszystkie pobrane wcześniej sztuki tego produktu nie zostaną zwrócone"
                                caption="VM_REQUIRE_ZERO_CONSUMPTION_FOR_DISTRIBUTION"
                                switchName="vend.VM_REQUIRE_ZERO_CONSUMPTION_FOR_DISTRIBUTION"
                                checked={formState.vend.VM_REQUIRE_ZERO_CONSUMPTION_FOR_DISTRIBUTION}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Wyświetlanie w katalogu produktów podczas pobierania ilości produktu załadowanej w podajniku"
                                caption="UI_SHOW_AVAILABLE_QUANTITY_IN_PRODUCT_CATALOG_WHILE_DISTRIBUTION"
                                switchName="vend.UI_SHOW_AVAILABLE_QUANTITY_IN_PRODUCT_CATALOG_WHILE_DISTRIBUTION"
                                checked={formState.vend.UI_SHOW_AVAILABLE_QUANTITY_IN_PRODUCT_CATALOG_WHILE_DISTRIBUTION}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Wyświetlanie struktury drzewiastej w katalogu podczas dystrybucji"
                                caption="UI_SHOW_TREE_STRUCTURE_ON_DISTRIBUTION"
                                switchName="vend.UI_SHOW_TREE_STRUCTURE_ON_DISTRIBUTION"
                                checked={formState.vend.UI_SHOW_TREE_STRUCTURE_ON_DISTRIBUTION}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Wyświetlanie tylko produktów przypisanych jako limit w stanach bieżących do punktu dystrybucyjnego"
                                caption="UI_SHOW_ONLY_ASSIGNED_TO_DP_ON_DISTRIBUTION"
                                switchName="vend.UI_SHOW_ONLY_ASSIGNED_TO_DP_ON_DISTRIBUTION"
                                checked={formState.vend.UI_SHOW_ONLY_ASSIGNED_TO_DP_ON_DISTRIBUTION}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Możliwość przełączania filtrów podczas dystrybucji"
                                caption="UI_SWITCHING_FILTERS_ON_DISTRIBUTION"
                                switchName="vend.UI_SWITCHING_FILTERS_ON_DISTRIBUTION"
                                checked={formState.vend.UI_SWITCHING_FILTERS_ON_DISTRIBUTION}
                                onChange={inputChanged}
                            />
                            <ListRow
                                label="Strategia kolejności wydawania produktów z komórek"
                                caption="VM_DISTRIBUTION_CELL_SELECT_STRATEGY"
                                name="vend.VM_DISTRIBUTION_CELL_SELECT_STRATEGY"
                                value={formState.vend.VM_DISTRIBUTION_CELL_SELECT_STRATEGY}
                                items={['CLOSEST_FIRST', 'OLDEST_LOADED_FIRST', 'MOST_LOADED_FIRST', 'LEAST_LOADED_FIRST', 'FIRST_EXPIRE', 'BY_LABEL']}
                                onChange={inputChanged}
                            />
                        </TabPanel>
                        <TabPanel value="return" sx={{ p: 0 }} className="configuration-option">
                            <SwitchRow
                                label="Wsparcie dla wykonywania zwrotów w ramach punktu dystrybucyjnego"
                                caption="VM_RETURNS_ENABLED"
                                switchName="vend.VM_RETURNS_ENABLED"
                                checked={formState.vend.VM_RETURNS_ENABLED}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Przypomnienie o niezwróconych produktach po zalogowaniu"
                                caption="VM_SHOW_RETURN_NOTIFICATION"
                                switchName="vend.VM_SHOW_RETURN_NOTIFICATION"
                                checked={formState.vend.VM_SHOW_RETURN_NOTIFICATION}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Zwrot do komórki o dowolnym rozmiarze gdy ma ustawiony właściwy schemat załadunku"
                                caption="VM_ALLOW_RETURNS_TO_CELLS_WITH_SCHEMA_WITH_DIFFERENT_SIZE"
                                switchName="vend.VM_ALLOW_RETURNS_TO_CELLS_WITH_SCHEMA_WITH_DIFFERENT_SIZE"
                                checked={formState.vend.VM_ALLOW_RETURNS_TO_CELLS_WITH_SCHEMA_WITH_DIFFERENT_SIZE}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Możliwość zwrotu z mniejszej do większej komórki"
                                caption="VM_ALLOW_RETURNS_TO_LARGER_CELLS"
                                switchName="vend.VM_ALLOW_RETURNS_TO_LARGER_CELLS"
                                checked={formState.vend.VM_ALLOW_RETURNS_TO_LARGER_CELLS}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="krywanie produktów jednorazowych podczas zwrotu"
                                caption="UI_CAN_RETURN_ONLY_RENTABLE"
                                switchName="vend.UI_CAN_RETURN_ONLY_RENTABLE"
                                checked={formState.vend.UI_CAN_RETURN_ONLY_RENTABLE}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Zwracanie częściowe"
                                caption="UI_FORCE_PARTIAL_RETURN"
                                switchName="vend.UI_FORCE_PARTIAL_RETURN"
                                checked={formState.vend.UI_FORCE_PARTIAL_RETURN}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Możliwość wyboru centrum kosztów podczas zwrotu produktu"
                                caption="UI_ASK_FOR_COST_CENTERS_ON_RETURN"
                                switchName="vend.UI_ASK_FOR_COST_CENTERS_ON_RETURN"
                                checked={formState.vend.UI_ASK_FOR_COST_CENTERS_ON_RETURN}
                                onChange={inputChanged}
                            />
                        </TabPanel>
                        <TabPanel value="replenishment" sx={{ p: 0 }} className="configuration-option">
                            <SwitchRow
                                label="Doładowywanie komórek przez klapki na podstawie schematu załadunku"
                                caption="VM_CELLS_REPLENISHMENT"
                                switchName="vend.VM_CELLS_REPLENISHMENT"
                                checked={formState.vend.VM_CELLS_REPLENISHMENT}
                                onChange={inputChanged}
                            />
                        </TabPanel>
                        <TabPanel value="cellsLabeling" sx={{ p: 0 }} className="configuration-option">
                            <ListRow
                                label="Metoda etykietowania komórek"
                                caption="VM_CELLS_LABELING"
                                name="vend.VM_CELLS_LABELING"
                                value={formState.vend.VM_CELLS_LABELING}
                                onChange={inputChanged}
                                items={['NO', 'SCHEMA', 'ALLOWED', 'MANDATORY']}
                            />
                            <SwitchRow
                                label="Ukrywanie etykiet niewymuszających serwisowania podczas zwrotu"
                                caption="UI_CAN_RETURN_ONLY_SERVICE_REQUIRED"
                                switchName="vend.UI_CAN_RETURN_ONLY_SERVICE_REQUIRED"
                                checked={formState.vend.UI_CAN_RETURN_ONLY_SERVICE_REQUIRED}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Automatyczne wybieranie jedynej dostępnej etykiety"
                                caption="UI_SKIP_SELECTION_FOR_SOLE_LABEL"
                                switchName="vend.UI_SKIP_SELECTION_FOR_SOLE_LABEL"
                                checked={formState.vend.UI_SKIP_SELECTION_FOR_SOLE_LABEL}
                                onChange={inputChanged}
                            />
                        </TabPanel>
                        <TabPanel value="productItems" sx={{ p: 0 }} className="configuration-option">
                            <SwitchRow
                                label="Obsługa egzemplarzy produktów"
                                caption="VM_PRODUCT_ITEMS_ENABLED"
                                switchName="vend.VM_PRODUCT_ITEMS_ENABLED"
                                checked={formState.vend.VM_PRODUCT_ITEMS_ENABLED}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Usuwanie przypisania egzemplarza produktu od punktu dystrybucyjnego po dystrybucji w trybie normalnym"
                                caption="VM_DETACH_PRODUCT_ITEM_AFTER_DISTRIBUTION"
                                switchName="vend.VM_DETACH_PRODUCT_ITEM_AFTER_DISTRIBUTION"
                                checked={formState.vend.VM_DETACH_PRODUCT_ITEM_AFTER_DISTRIBUTION}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Usuwanie egzemplarzy produktów z lokalnej bazy danych po dystrybucji w trybie normalnym"
                                caption="VM_PRODUCT_ITEMS_SINGLE_USE"
                                switchName="vend.VM_PRODUCT_ITEMS_SINGLE_USE"
                                checked={formState.vend.VM_PRODUCT_ITEMS_SINGLE_USE}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Automatyczne wybieranie jedynego dostępnego egzemplarza produktu"
                                caption="UI_SKIP_SELECTION_FOR_SOLE_ITEM"
                                switchName="vend.UI_SKIP_SELECTION_FOR_SOLE_ITEM"
                                checked={formState.vend.UI_SKIP_SELECTION_FOR_SOLE_ITEM}
                                onChange={inputChanged}
                            />
                        </TabPanel>
                        <TabPanel value="distributionRequests" sx={{ p: 0 }} className="configuration-option">
                            <SwitchRow
                                label="Obsługa żądań dystrybucji"
                                caption="VM_DISTRIBUTION_REQUEST_ENABLED"
                                switchName="vend.VM_DISTRIBUTION_REQUEST_ENABLED"
                                checked={formState.vend.VM_DISTRIBUTION_REQUEST_ENABLED}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Czas ważności tworzonych żądań wydania w dniach"
                                caption="VM_DISTRIBUTION_REQUEST_VALID_DAYS"
                                name="vend.VM_DISTRIBUTION_REQUEST_VALID_DAYS"
                                value={formState.vend.VM_DISTRIBUTION_REQUEST_VALID_DAYS}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Możliwość wyświetlania i zarządzania jedynie swoimi zleceniami wydań"
                                caption="VM_ENABLE_OWN_DR_MANAGEMENT"
                                switchName="vend.VM_ENABLE_OWN_DR_MANAGEMENT"
                                checked={formState.vend.VM_ENABLE_OWN_DR_MANAGEMENT}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Filtracja/widoczność zleceń dystrybucji utworzonych dla danego punktu dystrybucyjnego"
                                caption="UI_FILTER_LOCAL_DISTRIBUTION_REQUESTS"
                                switchName="vend.UI_FILTER_LOCAL_DISTRIBUTION_REQUESTS"
                                checked={formState.vend.UI_FILTER_LOCAL_DISTRIBUTION_REQUESTS}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Potwierdzanie przez użytkownika otrzymania towaru zgodnego z żądaniem dystrybucji"
                                caption="UI_USER_AUTH_AT_DR_REALIZATION"
                                switchName="vend.UI_USER_AUTH_AT_DR_REALIZATION"
                                checked={formState.vend.UI_USER_AUTH_AT_DR_REALIZATION}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Automatyczne akceptowanie zleceń dystrybucji"
                                caption="VM_DR_AUTO_ACCEPT_ENABLED"
                                switchName="vend.VM_DR_AUTO_ACCEPT_ENABLED"
                                checked={formState.vend.VM_DR_AUTO_ACCEPT_ENABLED}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Interwał pomiędzy kolejnymi próbami automatycznego zatwierdzania zleceń dystrybucji (sekundy)"
                                caption="VM_DR_AUTO_ACCEPT_INTERVAL"
                                name="vend.VM_DR_AUTO_ACCEPT_INTERVAL"
                                value={formState.vend.VM_DR_AUTO_ACCEPT_INTERVAL}
                                onChange={inputChanged}
                            />
                        </TabPanel>
                        <TabPanel value="inventoryTransfers" sx={{ p: 0 }} className="configuration-option">
                            <SwitchRow
                                label="Obsługa zleceń załadunków"
                                caption="VM_INVENTORY_TRANSFER_ENABLED"
                                switchName="vend.VM_INVENTORY_TRANSFER_ENABLED"
                                checked={formState.vend.VM_INVENTORY_TRANSFER_ENABLED}
                                onChange={inputChanged}
                            />
                        </TabPanel>
                        <TabPanel value="vsd" sx={{ p: 0 }} className="configuration-option">
                            Brak opisu na wiki
                            {/*  <SwitchRow
                                label="Włączenie brokera sesji"
                                caption="VSD_ENABLE"
                                switchName="vend.integration.vsdEnable"
                                checked={formState.vend.integration.vsdEnable}
                                onChange={inputChanged}
                            />
                            <TextRow
                                label="Ścieżka pipe'a dot. blokowania użytkownika"
                                caption="VSD_PIPE_LOCK_PATH"
                                name="vend.integration.pipeLockPath"
                                value={formState.vend.integration.pipeLockPath}
                                onChange={inputChanged}
                            />
                            <TextRow
                                label="Ścieżka pipe'a dot. odblokowywania użytkownika"
                                caption="VSD_PIPE_UNLOCK_PATH"
                                name="vend.integration.pipeUnlockPath"
                                value={formState.vend.integration.pipeUnlockPath}
                                onChange={inputChanged}
                            />
                            <TextRow
                                label="Ścieżka do katalogu z plikami obecnie zablokowanych użytkowników (nazwy plików to id użytkowników)"
                                caption="VSD_LOCK_FILES_PATH"
                                name="vend.integration.lockFilesPath"
                                value={formState.vend.integration.lockFilesPath}
                                onChange={inputChanged}
                            />*/}
                        </TabPanel>
                        <TabPanel value="frontend" sx={{ p: 0 }} className="configuration-option">
                            <ListRow
                                label="Typ ekranu głównego"
                                caption="UI_IDLE_SCR_TYPE"
                                name="vend.UI_IDLE_SCR_TYPE"
                                value={formState.vend.UI_IDLE_SCR_TYPE}
                                onChange={inputChanged}
                                items={['CLOCK', 'DIGITAL_CLOCK', 'SLIDESHOW']}
                            />
                            <NumberRow
                                label="Okres po którym nastąpi zmiana wyświetlanej grafiki na ekranie głównym"
                                caption="UI_IDLE_SCR_SLIDE_PERIOD"
                                name="vend.UI_IDLE_SCR_SLIDE_PERIOD"
                                value={formState.vend.UI_IDLE_SCR_SLIDE_PERIOD}
                                onChange={inputChanged}
                            />
                            <TextRow
                                label="Ścieżka do prezentacji"
                                caption="UI_SLIDES_PATH"
                                name="vend.UI_SLIDES_PATH"
                                value={formState.vend.UI_SLIDES_PATH}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Format czasu 12H"
                                caption="UI_CLOCK_12H_FORMAT"
                                switchName="vend.UI_CLOCK_12H_FORMAT"
                                checked={formState.vend.UI_CLOCK_12H_FORMAT}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Ukrywanie nieaktywnych/zablokowanych pozycji w menu głównym"
                                caption="UI_HIDE_INACTIVE_MENU_ITEMS"
                                switchName="vend.UI_HIDE_INACTIVE_MENU_ITEMS"
                                checked={formState.vend.UI_HIDE_INACTIVE_MENU_ITEMS}
                                onChange={inputChanged}
                            />
                            <ListRow
                                label="Ilość kolumn na liście katalogu produktów"
                                caption="UI_PRODCATALOG_COLNUM"
                                name="vend.UI_PRODCATALOG_COLNUM"
                                value={formState.vend.UI_PRODCATALOG_COLNUM.toString()}
                                onChange={inputChanged}
                                items={['1', '2']}
                            />
                            <ListRow
                                label="Ilość wierszy na liście katalogu produktów"
                                caption="UI_PRODCATALOG_ROWNUM"
                                name="vend.UI_PRODCATALOG_ROWNUM"
                                value={formState.vend.UI_PRODCATALOG_ROWNUM.toString()}
                                onChange={inputChanged}
                                items={['1', '2', '3', '4', '5', '6', '7']}
                            />
                            <NumberRow
                                label="Ilość kolumn na ekranie listy transakcji np. podczas zwrotów"
                                caption="UI_TRANSACTIONS_LIST_COLNUM"
                                name="vend.UI_TRANSACTIONS_LIST_COLNUM"
                                value={formState.vend.UI_TRANSACTIONS_LIST_COLNUM}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Ilość kolumn na ekranie listy transakcji np. podczas zwrotów"
                                caption="UI_TRANSACTIONS_LIST_ROWNUM"
                                name="vend.UI_TRANSACTIONS_LIST_ROWNUM"
                                value={formState.vend.UI_TRANSACTIONS_LIST_ROWNUM}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Ilość kolumn na ekranie listy użytkowników np. podczas zwrotów"
                                caption="UI_USERS_LIST_COLNUM"
                                name="vend.UI_USERS_LIST_COLNUM"
                                value={formState.vend.UI_USERS_LIST_COLNUM}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Ilość wierszy na ekranie listy użytkowników np. podczas zwrotów"
                                caption="UI_USERS_LIST_ROWNUM"
                                name="vend.UI_USERS_LIST_ROWNUM"
                                value={formState.vend.UI_USERS_LIST_ROWNUM}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Wyświetlanie nazw użytkowników na liście użytkowników oraz transakcji"
                                caption="UI_SHOW_USER_NAMES_ON_USERS_LIST"
                                switchName="vend.UI_SHOW_USER_NAMES_ON_USERS_LIST"
                                checked={formState.vend.UI_SHOW_USER_NAMES_ON_USERS_LIST}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Opóźnienie podczas wyszukiwania (w milisekundach)"
                                caption="UI_PATTERN_FILTER_DELAY"
                                name="vend.UI_PATTERN_FILTER_DELAY"
                                value={formState.vend.UI_PATTERN_FILTER_DELAY}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Ukrycie kontrolek konfiguracji filtrów"
                                caption="UI_HIDE_PRODUCT_CATALOG_CONFIG_WIDGET"
                                switchName="vend.UI_HIDE_PRODUCT_CATALOG_CONFIG_WIDGET"
                                checked={formState.vend.UI_HIDE_PRODUCT_CATALOG_CONFIG_WIDGET}
                                onChange={inputChanged}
                            />
                            <TextRow
                                label="Ścieżka do obrazków produktów"
                                caption="UI_IMAGES_PATH"
                                name="vend.UI_IMAGES_PATH"
                                value={formState.vend.UI_IMAGES_PATH}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Wykrywanie utraty responsywności aplikacji (milisekundy)"
                                caption="UI_PROFILING_EVENTLOOP_LAG"
                                name="vend.UI_PROFILING_EVENTLOOP_LAG"
                                value={formState.vend.UI_PROFILING_EVENTLOOP_LAG}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Pokazywanie trwającej aktualizacji danych cache'u"
                                caption="UI_SHOW_DS_CACHE_UPDATE_PENDING"
                                switchName="vend.UI_SHOW_DS_CACHE_UPDATE_PENDING"
                                checked={formState.vend.UI_SHOW_DS_CACHE_UPDATE_PENDING}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Wyświetlanie licznika klatek na sekundę (FPS) w lewym górnym rogu aplikacji"
                                caption="UI_SHOW_FPS_COUNTER"
                                switchName="vend.UI_SHOW_FPS_COUNTER"
                                checked={formState.vend.UI_SHOW_FPS_COUNTER}
                                onChange={inputChanged}
                            />
                        </TabPanel>
                        <TabPanel value="backend" sx={{ p: 0 }} className="configuration-option">
                            <SwitchRow
                                label="Deaktywowanie rzeczywistej komunikacji CAN"
                                caption="VM_NO_CAN_IFACE"
                                switchName="vend.VM_NO_CAN_IFACE"
                                checked={formState.vend.VM_NO_CAN_IFACE}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Sterowanie czasem emulacji zdarzeń otwarcia/zamknięcia klapek/drzwi przy zamockowanym CAN-ie"
                                caption="VM_CAN_WAIT_FLAP_CLOSE_MS"
                                name="vend.VM_CAN_WAIT_FLAP_CLOSE_MS"
                                value={formState.vend.VM_CAN_WAIT_FLAP_CLOSE_MS}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Sztuczne opóźnienie (w milisekundach) czasu chowania ekranu postępu dostępu do bazy danych"
                                caption="VM_DB_ACCESS_HIDE_DELAY_MS"
                                name="vend.VM_DB_ACCESS_HIDE_DELAY_MS"
                                value={formState.vend.VM_DB_ACCESS_HIDE_DELAY_MS}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Timeout w sekundach pokazywania ekranu postępu dostępu do bazy danych"
                                caption="VM_DB_ACCESS_TOUT_SEC"
                                name="vend.VM_DB_ACCESS_TOUT_SEC"
                                value={formState.vend.VM_DB_ACCESS_TOUT_SEC}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Korzystanie z wpisów dziennika dla nowo utworzonych obiektów"
                                caption="VM_NEW_ENTITY_JOURNAL"
                                switchName="vend.VM_NEW_ENTITY_JOURNAL"
                                checked={formState.vend.VM_NEW_ENTITY_JOURNAL}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Wymaganie zeskanowania kodu z egzemplarza produktu podczas jego zwrotu"
                                caption="VM_REQUIRE_PRODUCT_ITEM_SCAN"
                                switchName="vend.VM_REQUIRE_PRODUCT_ITEM_SCAN"
                                checked={formState.vend.VM_REQUIRE_PRODUCT_ITEM_SCAN}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Margines tolerancji przy wykrywaniu produktów ze skanerem produktów. Jednostka oznacza pozycję encodera"
                                caption="VM_SCAN_CELL_MARGIN"
                                name="vend.VM_SCAN_CELL_MARGIN"
                                value={formState.vend.VM_SCAN_CELL_MARGIN}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Skanowanie procentowego zapełnienia komórek. Wartość w procentach"
                                caption="VM_SCAN_CELL_PERCENTAGE_COVERAGE"
                                name="vend.VM_SCAN_CELL_PERCENTAGE_COVERAGE"
                                value={formState.vend.VM_SCAN_CELL_PERCENTAGE_COVERAGE}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Możliwość wykonania remanentu ze skanerem"
                                caption="VM_STOCKTAKING_WITH_CELL_SCANNER"
                                switchName="vend.VM_STOCKTAKING_WITH_CELL_SCANNER"
                                checked={formState.vend.VM_STOCKTAKING_WITH_CELL_SCANNER}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Czas po jakim pojawią się przyciski pomiń/powtórz podczas pobierania (sekundy)"
                                caption="VM_US_INACT_TOUT"
                                name="vend.VM_US_INACT_TOUT"
                                value={formState.vend.VM_US_INACT_TOUT}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Okres po którym włączy się alarm ZAMKNIJ KOMÓRKĘ (sekundy)"
                                caption="VM_US_CELL_OPENED_TOUT"
                                name="vend.VM_US_CELL_OPENED_TOUT"
                                value={formState.vend.VM_US_CELL_OPENED_TOUT}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Deaktywacja blokowania komórki na L40 gdy nastąpi nieuprawnione otwarcie"
                                caption="VM_L40_LOCK_ON_ILLEGAL_OPEN_DISABLED"
                                switchName="vend.VM_L40_LOCK_ON_ILLEGAL_OPEN_DISABLED"
                                checked={formState.vend.VM_L40_LOCK_ON_ILLEGAL_OPEN_DISABLED}
                                onChange={inputChanged}
                            />
                            <SwitchRow
                                label="Logowanie nowo utworzonych transakcji do systemu IDS"
                                caption="VM_LOG_NEW_TRANSACTION"
                                switchName="vend.VM_LOG_NEW_TRANSACTION"
                                checked={formState.vend.VM_LOG_NEW_TRANSACTION}
                                onChange={inputChanged}
                            />
                            <NumberRow
                                label="Maksymalny czas oczekiwania na wydanie produktu (sekundy)"
                                caption="VM_FLEX_EJECTION_TIMEOUT"
                                name="vend.VM_FLEX_EJECTION_TIMEOUT"
                                value={formState.vend.VM_FLEX_EJECTION_TIMEOUT}
                                onChange={inputChanged}
                            />
                        </TabPanel>
                    </CardContent>
                </Card>
            </TabContext>
        </Box>
    )
}


export default ApplicationTab;